import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { Moneda } from "../../../Helpers/Moneda";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";

export const EditarModelosModal = ({ open, onClose, modelos, onModificar, condiciones }) => {
    const [titulo, setTitulo] = useState("MODIFICAR SELECCIONES DE MODELO");
    const [lineaSeleccionada, setLineaSeleccionada] = useState("");
    const [lineasDisponibles, setLineasDisponibles] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    console.log(condiciones)
    const inputRef = useRef(null);

    const [modeloSeleccionado, setModeloSeleccionado] = useState(null);
    const [esquemaSeleccionado, setEsquemaSeleccionado] = useState("0");
    const [esquema, setEsquema] = useState(null);
    const [descuento, setDescuento] = useState(0);
    const [moneda, setMoneda] = useState("MXN");

    // console.log(modeloSeleccionado)

    useEffect(() => {
    if (open && condiciones && condiciones.length > 0 && modelos.length > 0) {
        const condicion = condiciones[0];

        const modeloCond = modelos.find(m => m.idmodelo === condicion.idmodelo);
        if (modeloCond) {
            setLineaSeleccionada(modeloCond.linea);
            setModeloSeleccionado(modeloCond);
            setDescuento(condicion.descuento || 0);
            setMoneda(condicion.moneda || "MXN");

            setEsquemaSeleccionado(condicion.esquema_pago || 0);
        }
    }
}, [open, condiciones, modelos]);


    useEffect(() => {
        if (modeloSeleccionado && modeloSeleccionado.idmodelo) {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`PromocionesDisponibles/ObtenerEsquemasporModelo?idmodelo=${modeloSeleccionado.idmodelo}`)
                .then((result) => {
                    setEsquema(result);
                    setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    console.error(error);
                    setLoader({ ...loader, mostrar: false });
                });
        } else {
            setEsquema([]); // Limpiar esquema si no hay modelo
        }
    }, [modeloSeleccionado]);


    const handleGuardarModelo = () => {
        if (onModificar) {
            const esquemaSeleccionadoPrecio = esquema.find(
                (es) => es.idpromocion === esquemaSeleccionado
            );

            onModificar({
                modelo: modeloSeleccionado,
                descuento,
                moneda,
                esquema_pago: esquemaSeleccionado,
                precio_promocion: esquemaSeleccionadoPrecio?.precio_promocion ?? null,
                esquema: esquemaSeleccionadoPrecio?.descripcion_promocion ?? null
            });
        }

        // Limpiar estados
        setModeloSeleccionado("");
        setEsquemaSeleccionado("");
        setDescuento(0);
        setMoneda("MXN");

        onClose();

        setTimeout(() => {
            inputRef.current?.focus();
        }, 100);
    };


    useEffect(() => {
        if (modelos && modelos.length > 0) {
            const lineas = [...new Set(modelos.map((m) => m.linea))];
            setLineasDisponibles(lineas);
        }
    }, [modelos]);

    const modelosFiltrados = useMemo(() => {
        if (!lineaSeleccionada) return [];
        return modelos.filter((m) => m.linea === lineaSeleccionada);
    }, [lineaSeleccionada, modelos]);


    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setDescuento(
            sinComas
        );
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="cotizaciones-modal-formulario">
                    <div className="cotizaciones-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={titulo}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`cotizaciones-modal-agregar-convenio`}>
                                    <div className="cotizaciones-modal-agregar-convenio-container">
                                        <div className="select-modelos">
                                            <FormControl fullWidth size="small" sx={{ mt: 2 }} disabled>
                                                <InputLabel id="linea-label">Línea</InputLabel>
                                                <Select
                                                    labelId="linea-label"
                                                    id="select-linea"
                                                    disabled
                                                    value={lineaSeleccionada}
                                                    label="Línea"
                                                    onChange={(e) => {
                                                        setLineaSeleccionada(e.target.value);
                                                        setModeloSeleccionado(null); // Limpiar modelo seleccionado al cambiar línea
                                                    }}
                                                    sx={{
                                                        height: '34px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        '& .MuiSelect-select': {
                                                            paddingY: '8px',
                                                        }
                                                    }}
                                                >
                                                    {lineasDisponibles.map((linea) => (
                                                        <MenuItem key={linea} value={linea}>
                                                            {linea}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <Autocomplete
                                                size="small"
                                                id="dash-modelo"
                                                fullWidth
                                                sx={{ mt: 2 }}
                                                freeSolo
                                                disabled
                                                value={modeloSeleccionado}
                                                onChange={(_, newValue) => {
                                                    setModeloSeleccionado(newValue);
                                                }}
                                                options={modelosFiltrados}
                                                getOptionLabel={(option) => option.mdl_descripcion || ""}
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.idmodelo}>
                                                        {option.mdl_descripcion}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Modelo"
                                                        inputRef={inputRef} // ✅ Aquí debe ir la ref
                                                    />
                                                )}
                                            />

                                            <TextField
                                                id="outlined-multiline-static"
                                                label="Descuento"
                                                size="small"
                                                sx={{
                                                    mt: 2
                                                }}
                                                fullWidth
                                                value={descuento}
                                                inputProps={{
                                                    style: { textAlign: "right" },
                                                }}
                                                onChange={({ target }) => {
                                                    ValOnlyNumber("descuento", target.value, onChange, true, 10);
                                                }}
                                                onKeyUp={(input) => Moneda(input.target)}
                                            />
                                        </div>
                                        <div className="cotizaciones-info-precio" style={{ marginTop: '1rem', textAlign: 'right' }}>
                                            {/* <div><strong>Precio Normal:</strong> {FormatMoney(modeloSeleccionado?.precio_lista ?? 0)}</div> */}
                                            <div><strong>Esquema:</strong> {esquema?.find(es => es.idpromocion === esquemaSeleccionado)?.descripcion_promocion ?? 'Sin esquema'}</div>
                                            <div><strong>Precio Final:</strong> {FormatMoney((esquema?.find(es => es.idpromocion === esquemaSeleccionado)?.precio_promocion ?? modeloSeleccionado?.precio_lista ?? 0) - descuento)}</div>
                                        </div>
                                    </div>
                                    <div className="cotizaciones-modal-buttons">
                                        <button
                                            className="cotizaciones-modal-button-guardar"
                                            onClick={() => handleGuardarModelo()}
                                        >
                                            Añadir Modelo
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};